export default __webpack_public_path__ + "static/media/stockimage.65b2992b.jpg";